import { render, staticRenderFns } from "./avards.vue?vue&type=template&id=465e628f&scoped=true"
import script from "./avards.vue?vue&type=script&lang=js"
export * from "./avards.vue?vue&type=script&lang=js"
import style0 from "./avards.vue?vue&type=style&index=0&id=465e628f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e628f",
  null
  
)

export default component.exports